import React from 'react';

import { css } from '@emotion/css';

import { useStyles } from '@/hooks/useStyles.ts';
import { Queries } from '@/queries/Queries.ts';
import { Theme } from '@/theme/CreateTheme.ts';
import { CardContent } from '@/uiKit/atoms/card/CardContent.tsx';
import { BirthDateField } from '@/uiKit/organisms/PatientCreationAndRenewal/PrescriptionInfo/FormFields/BirthDateField.tsx';
import { PrescriptionUploadField } from '@/uiKit/organisms/PatientCreationAndRenewal/PrescriptionInfo/FormFields/PrescriptionUploadField.tsx';
import { WeightField } from '@/uiKit/organisms/PatientCreationAndRenewal/PrescriptionInfo/FormFields/WeightField.tsx';

export type PrescriptionInfoFormContentProps = {
  patientInfo: {
    givenName: string;
    familyName: string;
  };
};

export const PrescriptionInfoFormContent: React.FC<
  PrescriptionInfoFormContentProps
> = ({ patientInfo }) => {
  const carePlanDirectives = Queries.practitioner.useCarePlanDirectives({});
  const styles = useStyles(makeStyles);

  return (
    <CardContent className={styles.container}>
      <WeightField />
      <BirthDateField />
      <PrescriptionUploadField
        patientInfo={patientInfo}
        carePlanStartDate={
          carePlanDirectives.carePlanCreationDataDirectives.periodStart
        }
      />
    </CardContent>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css`
    display: flex;
    flex-direction: column;
    padding-bottom: ${theme.spacing(10)};
    gap: ${theme.spacing(8)};
    width: 100%;
  `,
});
